export const AuthRoles: Record<string, string> = {
  manager: 'manager',
  operator: 'operator',
  employee: 'employee',
  resident: 'resident',
  service_provider: 'service_provider',
  visitor: 'visitor',
  visitor_company: 'visitor_company',
  visitor_residence: 'visitor_residence',
}

export const AuthRoles_PTBR: Record<string, string> = {
  manager: 'Admin',
  operator: 'Operador',
  employee: 'Colaborador',
  resident: 'Residente',
  service_provider: 'Prestador de serviço',
  visitor: 'Visitante',
  visitor_company: 'Visitante Empresa',
  visitor_residence: 'Visitante Residência',
}

export const AuthRoles_PT_EN: Record<string, string> = {
  Administrador: 'manager',
  Operador: 'operator',
  Colaborador: 'employee',
  Residente: 'resident',
  Prestador_de_Serviço: 'service_provider',
  Visitante: 'visitor',
  Visitante_Empresa: 'visitor_company',
  Visitante_Residência: 'visitor_residence',
}

export const AuthRoles_ES_EN: Record<string, string> = {
  Administrador: 'manager',
  Operator: 'operator',
  Empleado: 'employee',
  Residente: 'resident',
  Prestador_de_Servicio: 'service_provider',
  Visitor: 'visitor',
  Visitante_de_la_empresa: 'visitor_company',
  Visitante_a_domicilio: 'visitor_residence',
}

